<template>
  <div class="mainboxs">
    <div class="mainbox">
      <div class="news_til">
        <div class="news_til_left">
          <div class="news_til_left_logo">
            <img src="~@/assets/img/TechnicalCollege/31.png" alt="">
          </div>
          <div class="news_til_left_til">{{ schoolName }}主考院校</div>
        </div>
        <div @click="goNext('/gxGather/academy')" class="news_til_right">查看更多 <img
            src="~@/assets/img/TechnicalCollege/48.png" alt=""></div>
      </div>
      <div class="line"></div>
      <div class="academy_list">
        <div @click="goPointLink()" class="academy_list_item">
          <img :src="sImg" alt="">
        </div>
        <div @click="goNext(`/gxGathers/index?id=${item.id}`)" v-for="(item, index) in majorList" :key="index">
          <div class="school_img">
            <img :src="item.schoolImg" alt="">
            <div class="school_logo">
              <img :src="item.schoolBadge" alt="">
            </div>
          </div>
          <div class="school_detail">
            <div class="school_address">
              <img style="width: 10px;height: auto;margin-right: 5px;" src="~@/assets/img/TechnicalCollege/81.png"
                alt="">
              {{ item.areaProvinceName }} {{ item.areaCityName }}
            </div>
            <div class="school_name"> {{ item.schoolName }} </div>
            <div class="school_major elp"> <span>招生专业：</span> {{ item.majorName }} </div>
            <div class="lines"></div>
            <div class="school_msg">
              <div>招生简章</div>
              <div>常见问题</div>
              <div>报考咨询</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Know } from "@/api/know";
let know = new Know();
import { getDomain } from "@/api/cookies";
export default {
  components: {},
  props: {
    whichSchoolId: {
      type: String,
    },
    schoolName: {
      type: String,
    },

  },
  data() {
    return {
      whichNews: 1,
      sImg: '',
      link: '',
      majorList: []
    };
  },
  created() {
    this.selectProjectSchoolPcList()
    this.getAdvertConfiguration()
  },
  mounted() {

  },
  methods: {
    chooseMajor(i) {
      this.whichNews = i
    },
    selectProjectSchoolPcList() {
      know.selectProjectSchoolPcList({
        pageNum: 1,
        pageSize: 6,
        projectCategoryId: this.whichSchoolId,
      })
        .then((res) => {
          this.majorList = res.rows
        });
    },
    getAdvertConfiguration() {
      know.getAdvertConfiguration({
        categoryId: this.whichSchoolId,
      })
        .then((res) => {
          this.sImg = res.data ? res.data[0].cover : ''
          this.link = res.data ? res.data[0].url : ''
        });
    },
    goPointLink() {
      if (this.link) {
        window.open(this.link, '_blank');

      }
    }

  },
};
</script>

<style lang="less" scoped>
.mainboxs {
  background: #F5F7F9;
  padding: 20px;
  padding-bottom: 0;
  padding-top: 0px;
}

.mainbox {
  width: 1200px;
  margin: 0 auto;
  padding-top: 15px;


  .news_til {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .news_til_left {
      display: flex;
      align-items: center;

      .news_til_left_logo {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: #E9F4FF;
      }

      .news_til_left_til {
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei-Bold;
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        margin-left: 5px;
      }
    }

    .news_til_right {

      font-family: PingFangSC-Regular, PingFangSC-Regular;
      font-weight: normal;
      font-size: 14px;
      color: #777777;
      display: flex;
      align-items: center;

      img {
        width: 10px;
        height: 10px;
        margin-left: 4px;
      }
    }
  }

  .line {
    width: 1200px;
    height: 0px;
    border-bottom: 1px solid #DCDCDC;
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .academy_list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    >div {
      width: 280px;
      height: 286px;
      background: #FFFFFF;
      box-shadow: 0px 3px 11px 1px rgba(7, 15, 32, 0.08);
      border-radius: 6px 6px 6px 6px;
      margin-right: 20px;
      margin-bottom: 20px;
      cursor: pointer;
      transition: transform 0.6s ease;


      .school_img {
        width: 280px;
        height: 114px;
        border-radius: 6px 6px 0 0;
        // overflow: hidden;
        position: relative;

        img {
          border-radius: 6px 6px 0 0
        }

        .school_logo {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          left: 10px;
          bottom: -30px;
          position: absolute;

          img {
            border-radius: 50%;

          }
        }
      }

      .school_detail {
        padding: 20px;
        padding-top: 10px;

        .school_address {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: normal;
          font-size: 12px;
          color: #666666;
        }

        .school_name {

          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei-Bold;
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          margin-top: 10px;
        }

        .school_major {
          width: 230px;

          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: normal;
          font-size: 12px;
          color: #333333;
          margin-top: 12px;

          span {

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 12px;
            color: #666666;
          }
        }

        .lines {
          width: 100%;
          height: 0px;
          border: 1px solid #F7F7F7;
          margin: 14px 0;
        }

        .school_msg {
          display: flex;
          justify-content: space-between;

          >div {
            width: 74px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;

            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: normal;
            font-size: 12px;
          }

          >div:nth-child(1) {
            background: url('~@/assets/img/TechnicalCollege/53.png');
            background-size: 100% 100%;
            color: #3D6CC8;

          }

          >div:nth-child(2) {
            background: url('~@/assets/img/TechnicalCollege/54.png');
            background-size: 100% 100%;
            color: #DF932F;

          }

          >div:nth-child(3) {
            background: url('~@/assets/img/TechnicalCollege/55.png');
            background-size: 100% 100%;
            color: #BC3535;

          }
        }
      }

    }

    >div:hover {
      transform: scale(1.1)
    }

    >div:nth-child(3),
    >div:nth-child(7) {
      margin-right: 0;
    }

    .academy_list_item {
      width: 580px;
      height: 286px;
      z-index: 99;
      border-radius: 8px;
      overflow: hidden;
    }
  }


}

img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>